import type React from 'react';
import {Stack} from '@mui/material';
import {Tag} from '~/components/tag/Tag';
import {ProfileSection} from '../components/ProfileSection';

type Props = {
    title: React.ReactNode;
    /** True once a user changed the section; until then it shows the rule-based draft. */
    edited: boolean;
    actions?: React.ReactNode;
    children: React.ReactNode;
};

/** A plan section with its provenance: "Drafted from your data" until somebody edits it, then "Edited". */
export const PlanSection: React.FC<Props> = ({title, edited, actions, children}) => (
    <ProfileSection
        title={title}
        actions={
            <Stack direction="row" gap={1} alignItems="center" sx={{ml: 'auto'}}>
                {actions}
                <Tag size="small" solid={false} color={edited ? 'default' : 'info'}
                     label={edited ? 'Edited' : 'Drafted from your data'}/>
            </Stack>
        }
    >
        {children}
    </ProfileSection>
);
